import { render } from "./ZamgRectangleAdd.vue?vue&type=template&id=e3e35a24&ts=true"
import script from "./ZamgRectangleAdd.vue?vue&type=script&lang=ts"
export * from "./ZamgRectangleAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__